import React, { memo } from 'react';

import Styled from '@/components/atomic/atoms/layout/image/img/styled';
import type { ImgProps } from '@/components/atomic/atoms/layout/image/typing';
import type { ViewProps } from '@/components/atomic/atoms/layout/view/typings';
import withExposer from '@/hocs/with-exposer';
import type { BasicComponentProps } from '@/typings/generic';

const ImgComponent: React.FC<ImgProps & ViewProps & BasicComponentProps> = (
	props,
) => <Styled {...props} />;

const Img = memo(withExposer(ImgComponent, 'img'));

export default Img;
